import { render, staticRenderFns } from "./professorKnow.vue?vue&type=template&id=76e17a02&scoped=true&"
import script from "./professorKnow.vue?vue&type=script&lang=js&"
export * from "./professorKnow.vue?vue&type=script&lang=js&"
import style0 from "./professorKnow.vue?vue&type=style&index=0&id=76e17a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e17a02",
  null
  
)

export default component.exports